<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import TextSection from "text-section";

export default {
  mixins: [fandomBasicMixin],
  components: {
    TextSection
  },
  props: {
    animation: {
      type: Boolean,
      default: true
    },
    customShareSlug: {
      type: String,
      default: ""
    },
  },
  data() {
    return {};
  },
  mounted: function() {
    Vue.nextTick(() => {
      // Animation management.
      if (this.animation) {
        this.registerAnimation();
      }
    });
  },
  methods: { },
  computed: {
    contentClasses() {
      const classes = [];

      if (this.content.boxed) {
        classes.push("inset");
      }

      classes.push(this.content.theme ? `${this.content.theme}-theme` : "");

      if (!(Fandom.exists(this.content.height) && this.content.height.indexOf("$") != 0)) {
        classes.push("mh-100vh-header-sm");
      }

      // Mobile reverse management. Default image and text
      if ((globalState.viewport.sm || globalState.viewport.xs) && this.content.reverse_mobile) {
        classes.push("flex-column-reverse");
      } else if (this.content.reverse) {
        classes.push("flex-row-reverse");
      }
      
      return classes;
    },
    contentStyle() {
      let style = {
        "min-height": (Fandom.exists(this.content.height) && this.content.height.indexOf("$") !== 0) ? this.content.height : 'auto', // Height management. Default 100vh.
      };
      if (this.content.background_color) {
        style["background-color"] = this.content.background_color;
      }

      if (this.content.text_color) {
        style["color"] = this.content.text_color;
      }
      return style;
    }
  },
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="[contentType, {'inview_animate': animation}]" v-if="isContentVisibleToUser()" :id="contentId" two-col-text-component>
    <div class="container-fluid position-relative overflow-hidden">
      <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
      <div 
        v-if="content.background_image"
        :style="{'background-image': getContentResponsiveImageURL('background_image')}"
        class="row m-0 w-100 h-100 position-absolute-center bg-cover-center inview_animate_zoom" 
      ></div>
      <div class="position-absolute-center w-100 h-100 layer" v-if="content.background_image"></div>
      <div class="row" :class="contentClasses" :style="contentStyle">
        <div class="col-12 col-md-6 d-flex flex-column justify-content-center py-4 text-column">
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <text-section :content="content.left_column" :opt-container-content="containerContent" :custom-share-slug="customShareSlug"></text-section>
            </div>
          </div>
        </div>
        <div class="col-10 col-md-6 d-flex flex-column justify-content-center py-4 text-column">
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <text-section :content="content.right_column" :opt-container-content="containerContent" :custom-share-slug="customShareSlug"></text-section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[two-col-text-component] {
  > div > .row.inset {
    padding: 5rem;
  }

  @include media-breakpoint-down(md) {
    > div > .row.inset {
      padding: 0;
    }
  }

  /* IE11 hack */
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {

    > div > .row {
      max-height: 1080px;
    }

    .media-column,
    .text-column {
      min-height: inherit;
      max-height: 1080px;
    }

  }
}
</style>